import { code, Later } from "../../client/index.ts";
import { Icon } from "../../design/Icon.tsx";
import { nabla } from "../../design/icons/index.ts";
import { Card } from "../../design/primitives/Card.tsx";
import { shellCopy } from "../copy.ts";
import styles from "./Errors.module.css";

const entrances = code(() => import("../../features/auth/index.ts"));
const agency = code(() => import("./AgencyDoor.tsx"));

export function SignedOut({ reason }: { readonly reason: "terminou" | "saiu" }) {
  return (
    <main className={styles.signedOut} id="conteudo">
      <Card>
        <div className={styles.card}>
          <span className={styles.mark}>
            <Icon svg={nabla} size={24} />
          </span>
          <h1 className={styles.title}>{reason === "saiu" ? shellCopy.sessao.saiu : shellCopy.sessao.terminou}</h1>
          <Later parts={entrances}>{({ PublicEntrances }) => <PublicEntrances />}</Later>
          <Later parts={agency}>{({ default: AgencyDoor }) => <AgencyDoor reason={reason} />}</Later>
        </div>
      </Card>
    </main>
  );
}
